import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../../auth/auth.service';
import {Injectable} from '@angular/core';

@Injectable()
export class UploadReportsGuard  {
  constructor(private router: Router, private authService: AuthService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.authService.isRoleAdmin;
  }
}
